import { Component, OnInit, Injector, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { FilterableService } from '../../../filterable-service';
import { AuthorizationService, WorkOrderScheduleService } from '../../../ve.service';
import { AuthenticationService } from '../../../../../auth.service';
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';

const PLACEHOLDER = 'placeholder';

@Component({
  selector: 'wo-assign-form',
  templateUrl: './wo-assign-form.component.html'
})
export class WoAssignFormComponent implements OnInit {
  public readonly workOrderSchedulService: WorkOrderScheduleService;
  public readonly authorizationService: AuthorizationService;
  public readonly authService: AuthenticationService;
  public engineerService = new FilterableService();
  public module: any;
  public isLoading = false;
  public isEngineerListLoading = false;

  data: any = {};
  public isVacationCreation = false;
  public formGroup: UntypedFormGroup;
  formBuilder: UntypedFormBuilder;

  constructor(
    private readonly injector: Injector,
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<WoAssignFormComponent>,
    public cgpSnackbarService: CgpSnackbarService,

  ) {
    this.authorizationService = injector.get(AuthorizationService);
    this.workOrderSchedulService = injector.get(WorkOrderScheduleService);
    this.authService = injector.get(AuthenticationService);
    this.formBuilder = this.injector.get(UntypedFormBuilder);
    this.data = data;
    this.formGroup = this.formBuilder.group(addNewScheduleForm);
    this.formGroup.get('PlannedCompletionDate').setValue(this.data.requiredDate);
    this.formGroup.get('WorkOrderId').setValue(this.data.workOrderId);
    this.module = this.authService.getModule();
  }

  ngOnInit() {
    const moduleNameContents = this.module.split('_');
    const reverseModuleName = `${moduleNameContents[1]}_${moduleNameContents[0]}`;
    this.isLoading = true;
    this.isEngineerListLoading = true;
    this.authorizationService.read(`/roleusers?role=${reverseModuleName}_Engineer`)
      .then(users => {
        this.engineerService.next(users.sort((a, b) => a.FirstName.localeCompare(b.FirstName)));
        this.isLoading = false;
        this.isEngineerListLoading = false;
      })
      .catch(error => {
        this.isLoading = false;
        this.isEngineerListLoading = false;
      });
  }

  onYesClick(): any {
    this.createSchedule();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  isDisabled() {
    return !this.formGroup.valid;
  }

  public createSchedule() {
    this.isLoading = true;
    this.setDateTime();
    this.formGroup.get('ModuleName').setValue(this.module);
    this.workOrderSchedulService.save(this.formGroup.value, true, '', false)
      .then(response => {
        this.isLoading = false;
        this.cgpSnackbarService.showSnackbar({
          message: 'Work Order assigned',
          duration: 5000,
        });
        this.dialogRef.close(response);
      })
      .catch(() => {
        this.isLoading = false;
        this.cgpSnackbarService.showSnackbar({
          message: 'Work Order assignment failed.',
          duration: 5000,
        });
        this.dialogRef.close();
      });
  }

  /**
   * Defines the standard 8-5 hours for the planned starting and ending dates.
   *
   * @param {*} dataItem
   * @memberof WorkOrderScheduleEditService
   */
  setDateTime() {
    const planedStartTime = new Date(this.formGroup.get('PlannedStartDate').value);
    planedStartTime.setHours(8, 0, 0, 0);
    this.formGroup.get('PlannedStartDate').setValue(planedStartTime);

    const planedEndTime = new Date(this.formGroup.get('PlannedCompletionDate').value);
    planedEndTime.setHours(17, 0, 0, 0);
    this.formGroup.get('PlannedCompletionDate').setValue(planedEndTime);
  }
}

export const addNewScheduleForm = {
  Id: [],
  PlannedStartDate: ['', Validators.required],
  PlannedCompletionDate: ['', Validators.required],
  AssignedEngineer: ['', Validators.required],
  WorkOrderId: ['', Validators.required],
  ModuleName: [],
};
